import { ComponentMessage } from '../../../../enums/ComponentMessage';

export const NO_CELL_VALUE_MESSAGE = ComponentMessage.NoDataShort;
